<template>
  <div>
    <Label 
      v-if="label"
      :class="[
        'text-xs block mb-1',
        showInherited ? 'text-orange-600' : 'text-muted-foreground'
      ]"
    >
      {{ label }}
    </Label>
    <div class="relative">
      <slot :show-inherited-border="showInherited" />
      <ResetButton 
        :show="showOverridden" 
        @reset="$emit('reset')" 
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Label } from '@/components/ui/label'
import ResetButton from './ResetButton.vue'

interface Props {
  label?: string
  isInherited?: boolean
  isOverridden?: boolean
  parentSceneName?: string
}

const props = withDefaults(defineProps<Props>(), {
  isInherited: false,
  isOverridden: false,
  parentSceneName: 'Parent'
})

defineEmits<{
  reset: []
}>()

// Only show inherited styling if inherited and NOT overridden
const showInherited = computed(() => props.isInherited && !props.isOverridden)

// Only show reset button if inherited AND overridden
const showOverridden = computed(() => props.isInherited && props.isOverridden)
</script>
